import {
  TrendingUpIcon,
  ActivityIcon,
  HeartHandshakeIcon,
  ShieldCheckIcon,
  ClipboardCheckIcon,
  PrinterIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const frameworkItems: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: TrendingUpIcon,
    title: 'Progressive Learning',
    description: 'A clear sequence helps you know what to teach next.',
  },
  {
    icon: ActivityIcon,
    title: 'Ready-to-Use Activities',
    description: 'Practical instructions designed for real PE environments.',
  },
  {
    icon: HeartHandshakeIcon,
    title: 'Inclusive Adaptations',
    description: 'Flexible entry points for mixed abilities and participation needs.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Safety Guidance',
    description: 'Clear considerations for setup, movement, space, and supervision.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Assessment Tools',
    description: 'Simple ways to observe learning and collect useful evidence.',
  },
  {
    icon: PrinterIcon,
    title: 'Printable Resources',
    description: 'Checklists, planners, matrices, reflection tools, and student sheets.',
  },
]
